import { DataBean } from "../DataBean";

export class QualityGarmentStandars extends DataBean {

  public async getQualityGarmentStandarsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityGarmentStandarsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteQualityGarmentStandars(idqualitygarmentstandars: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityGarmentStandars_Number", [idqualitygarmentstandars]);
  }

  public async updateQualityGarmentStandars(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityGarmentStandars_updateQualityGarmentStandars_com.orange.finance.processcontract.bean.QualityGarmentStandars",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityGarmentStandars",
        },
      ]
    );
  }
}
